<template>
  <div class="pb-2">
    <div class="p-2">

      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <validation-provider
            #default="{ errors }"
            name="IV"
            rules="required"
          >
            <input-field
              name="raw_key-iv"
              label="IV *"
              :error="errors.length ? errors[0] : null"
              label-position="top"
            >
              <b-form-input
                id="raw_key-iv"
                v-model="settings.iv"
                :state="errors.length > 0 ? false:null"
                placeholder="Enter IV..."
              />

            </input-field>
          </validation-provider>

        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <validation-provider
            #default="{ errors }"
            name="PSSH"
            rules="required"
          >

            <input-field
              name="raw_key-pssh"
              :error="errors.length ? errors[0] : null"
              label="PSSH *"
              label-position="top"
            >
              <b-form-input
                id="raw_key-pssh"
                v-model="settings.pssh"
                :state="errors.length > 0 ? false:null"
                placeholder="Enter PSSH..."
              />
            </input-field>
          </validation-provider>
        </b-col>
      </b-row>
    </div>
    <div class="d-flex flex-column border-default border-t rawKeyTable">
      <div class="d-flex justify-content-between align-items-center p-2">
        <div class="text-lg text-thick">
          Raw Keys
        </div>
        <b-button
          variant="outline-primary"
          class="px-2"
          size="sm"
          @click="addNewRawKey"
        >
          Add
        </b-button>
      </div>
      <div class="default-table shadow-none border-none table-compact">
        <b-table-simple
          responsive
          class="loaded"
          table-class="mt-0"
        >
          <b-thead>
            <b-tr>
              <b-th>
                Label
              </b-th>
              <b-th>
                Key ID
              </b-th>
              <b-th>
                Key
              </b-th>
              <b-th />
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="item in rawKeyTableItems"
              :key="item.id"
            >
              <b-td class="pb-0">
                <validation-provider
                  #default="{ errors }"
                  name="Label"
                  rules="required"
                >
                  <b-form-input
                    v-model="item.label"
                    placeholder="Enter label here..."
                    :state="errors.length > 0 ? false:null"
                    class="mb-0"
                  />
                </validation-provider>

              </b-td>
              <b-td class="pb-0">
                <validation-provider
                  #default="{ errors }"
                  name="label"
                  rules="required"
                >
                  <b-form-input
                    v-model="item.keyId"
                    placeholder="Enter key id here..."
                    :state="errors.length > 0 ? false:null"
                    class="mb-0"
                  />
                </validation-provider>

              </b-td>
              <b-td class="pb-0">
                <validation-provider
                  #default="{ errors }"
                  name="label"
                  rules="required"
                >
                  <b-form-input
                    v-model="item.key"
                    placeholder="Enter key here..."
                    :state="errors.length > 0 ? false:null"
                    class="mb-0"
                  />
                </validation-provider>
              </b-td>
              <b-td class="pb-0">
                <span
                  class="cursor-pointer"
                  @click="removeRawKey(item.id)"
                >
                  <GjIcon name="Delete" />
                </span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
  </div>
</template>
<script>

import InputField from '@/components/form/InputField.vue'
import { v4 as uuidv4 } from 'uuid'
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'RawKey',
  components: {
    InputField,
    ValidationProvider,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      rawKeyField: {
        label: '',
        keyId: '',
        key: '',
        tdClass: 'pb-0',
      },
    }
  },
  computed: {
    rawKeyTableItems() {
      return this.settings.rawKeys
    },
  },
  beforeMount() {
    this.settings.rawKeys.forEach(el => {
      el.id = uuidv4()
    })
  },
  methods: {
    addNewRawKey() {
      this.settings.rawKeys.push({ ...this.rawKeyField, id: uuidv4() })
    },
    removeRawKey(id) {
      this.settings.rawKeys = this.settings.rawKeys.filter(item => item.id !== id)
    },
  },

}
</script>
<style>
  .rawKeyTable table tr td{
    padding-bottom:5px;
  }
</style>
